import Cookies from 'js-cookie'

$(document).ready(function () {

    if (Cookies.get('cookiealert') != 'closed') {

        // show the alert

        $("#cookie-alert-container")
            .show(0, function (event) {
                Cookies.set('cookiealert', 'closed', {'expires': 365});
            })
            .delegate("a.close", "click", function (event) {

                event.preventDefault();

                $(this).fadeOut(function (event) {

                    $("#cookie-alert-container").remove();

                    Cookies.set('cookiealert', 'closed', {'expires': 365});
                });

            });
    }

});